/**
 * 销售日报和销售任务
 */
const iframe = () => import('@/pages/views/iframe-wrapper/index');

export default {
	path: 'iframe',
	name: 'iframeApp',
	component: iframe,
	meta: {
		trust: true,
		noNeedLogin: true
	}
}
